import { IconVerifiedCheck } from "@/lib/images";
import { StaticImageData } from "next/image"

export const Text_Mobile_App_That_Section = {
heading : "Mobile Apps That Power Your Business",
sub_heading : "We design and build high-performance mobile apps that are fast, intuitive, and tailored to your business—end to end.",
button_value : "Schedule Consultation Call",
button_href : "/contact-us"
}

interface IListItemMobileAppThat{
    icon : StaticImageData;
    icon_alt : string;
    list_text : string;

}
 
export const List_Item_Mobile_App_That_Section : IListItemMobileAppThat[] = [
    {
        icon : IconVerifiedCheck,
        icon_alt : "Icon Verified Check",
        list_text : "Pixel-Perfect Designs"
    },
    {
        icon : IconVerifiedCheck,
        icon_alt : "Icon Verified Check",
        list_text : "Built for any Screen"
    },
    {
        icon : IconVerifiedCheck,
        icon_alt : "Icon Verified Check",
        list_text : "Multi-Platform Mobile Apps"
    },
    {
        icon : IconVerifiedCheck,
        icon_alt : "Icon Verified Check",
        list_text : "Native Feel"
    },
    
]